

export const SEND_USER_IDENTIFIER_ROUTE = '/server/identifier/user';
export const SEND_USER_IDENTIFIER = 'SEND_USER_IDENTIFIER';
export const SEND_USER_IDENTIFIER_SUCCESS = 'SEND_USER_IDENTIFIER_SUCCESS';